import {
  clinicInfoSchema,
  realtimeOverviewSchema,
  type ClinicIdentity,
  type RealtimeOverview,
} from './overview-contracts'

function cleanText(value: string | undefined) {
  const cleaned = value?.trim()
  return cleaned ? cleaned : null
}

export function parseClinicIdentity(value: unknown): ClinicIdentity | null {
  const parsed = clinicInfoSchema.safeParse(value)
  if (!parsed.success) return null

  return {
    name:
      cleanText(parsed.data.dentistryName) ??
      cleanText(parsed.data.dentistry_name),
    address:
      cleanText(parsed.data.dentistryAddress) ??
      cleanText(parsed.data.dentistry_address),
  }
}

export function parseRealtimeOverview(
  value: unknown,
  nowMs = Date.now()
): RealtimeOverview | null {
  const parsed = realtimeOverviewSchema.safeParse(value)
  if (!parsed.success) return null
  const maxAcceptedProducerTime = nowMs + 5 * 60 * 1000
  if (
    parsed.data.updatedAtMs > maxAcceptedProducerTime ||
    parsed.data.coverageStartedAtMs > maxAcceptedProducerTime
  ) {
    return null
  }
  return parsed.data
}
